<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.9163 4.58333H20.1663V6.41667H11.9163V4.58333ZM1.83301 6.41667H8.24967V8.25H10.083V2.75H8.24967V4.58333H1.83301V6.41667ZM8.24967 15.5833H20.1663V17.4167H8.24967V15.5833ZM17.4163 10.0833H20.1663V11.9167H17.4163V10.0833ZM15.583 13.75V8.261H13.7497V10.0833H1.83301V11.9167H13.7497V13.75H15.583ZM6.41634 19.25V13.75H4.58301V15.5833H1.83301V17.4167H4.58301V19.25H6.41634Z"
            fill="currentColor" fill-opacity="0.9" />
    </svg>

</template>